// extracted by mini-css-extract-plugin
export default {"container":"SZ-z","list":"TZ-z"};